export default "__VITE_ASSET__DUyk9znl__"